import React, { Component } from 'react';
import axios from "axios";
import compareValues from './SortValue.js';
class HeadCountMRC extends Component {
    constructor(props) {
        super(props);
        this.state = {
            HeadCountMRCItemData: [],
            mrccode: '',
            hcmrcname: '',
            isMandatory: false,
            selectedvalue: '',
            isLoaded: false
        }
    }
    async  componentDidMount() {
        if (this.props.headCountMRCCode != '') {
            this.setState({ mrccode: this.props.headCountMRCCode, hcmrcname: this.props.headCountMRCName, selectedvalue: this.props.headCountMRCCode })
        }
        if (this.props.mngwwid != '' && this.props.locationreferenceID != '') {
            await axios({
                method: 'POST',
                url: process.env.REACT_APP_WORKDAY_API_URL + 'getHeadCountMRC',
                headers: {
                    'apiKey': process.env.REACT_APP_WORKDAY_API_KEY,
                    'clientKey': process.env.REACT_APP_WORKDAY_API_CLIENTKEY,
                    'Content-Type': 'application/json'
                },
                data: { "managerWWID": this.props.mngwwid, "locationCode": this.props.locationreferenceID, "sessionId": this.props.sessionID, "leCode": this.props.lecode }
            }).then((res) => {
                this.setState({
                    HeadCountMRCItemData: res.data.headCountMRCList,
                    isLoaded: true
                });
            }).catch((error) => {
                //on error
                // alert("There is an error in API call mngid.");
            });
        }
        else {

        }
    }
    HeadCountMRCData = (legalitemdata) => {
        if (legalitemdata.length > 0) {
            let headcountMRCDataSort = legalitemdata.sort(compareValues('headCountMRCCode'));
            return (
                headcountMRCDataSort.map((item) =>
                    <li key={item.headCountMRCCode} value={item.headCountMRCCode}

                        className={this.state.selectedvalue == item.headCountMRCCode ? 'lilist select-search-box__row lelist changebgcolor'
                            : 'lilist select-search-box__row lelist'}
                        onClick={(e) => { this.handleCheck(item.headCountMRCCode, item.headCountMRCName) }}><span className="leradiospan"><input type="radio" name="radio" id={item.headCountMRCCode}
                            checked={this.state.mrccode === item.headCountMRCCode}
                            value={item.headCountMRCName} onChange={(e) => { this.handleCheck(item.headCountMRCCode, item.headCountMRCName) }}></input>
                        </span><span className="hmrctext" title={item.headCountMRCName}>{item.headCountMRCCode} - {item.headCountMRCName}</span>
                    </li>)
            )
        }
    }
    handleCheck = (id, val) => {
        this.setState({ mrccode: id, hcmrcname: val, selectedvalue: id })
    }
    handleHeadcountMRCData = () => {
        if (this.state.mrccode != '') {
            this.props.onclickHeadCountMRCNext(this.state.mrccode, this.state.hcmrcname);
            this.setState({ isMandatory: false })
        }
        else {
            this.setState({ isMandatory: true })
        }

    }
    handleHeadCountMRCDataBack = () => {
        this.props.onclickHeadCountMRCBack();
    }

    render() {
        return (
            <div>
                {this.state.isLoaded ?
                    <div>
                        <h4 className="listheader">Please select a recommended <span className="listheadertext">Headcount MRC:</span></h4>
                        <ul className='ulist'>
                            {this.HeadCountMRCData(this.state.HeadCountMRCItemData)}
                            <li className={this.state.selectedvalue == "noa" ? 'lenoneoftheabove changebgcolor' : 'lenoneoftheabove'}
                                onClick={(e) => { this.handleCheck("noa", "noa") }} >
                                <span className="leradiospan"><input type="radio" id="noa"
                                    name="radio" value="noa" checked={this.state.mrccode === "noa"}
                                    onChange={(e) => { this.handleCheck("noa", "noa") }}></input></span>
                                <span className="hmrctext" title="None of the above">None of the above </span> </li>
                        </ul></div>
                    : <div className='dataLoader'>Loading data please wait...</div>}
                {this.state.isMandatory === true ?
                    <label className="MandatoryFields">
                        Please select a recommended Headcount MRC
                                </label> : ''}
                {this.state.isLoaded ?
                    <div className='last-column rowhead lebtn'>
                        <div className="nextbtn leback"> <input type="submit" value="< Back"
                            className="btncls" onClick={this.handleHeadCountMRCDataBack} /></div>
                        <div className="nextbtn lenext"> <input type="submit" value="Next >"
                            onClick={this.handleHeadcountMRCData} className="btncls" /></div>
                    </div> : ''}
            </div>
        );
    }
}

export default HeadCountMRC;